'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleOpenChange = undefined;

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var _createPostMessageAction = require('./createPostMessageAction');

var handleOpenChange = exports.handleOpenChange = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.OPEN_CHANGE);


//////////////////
// WEBPACK FOOTER
// ./js/post-message/actions/handleOpenChange.js
// module id = 906
// module chunks = 2 3